import classNames from 'classnames/bind';
import React from 'react';

import ClickPoint from './01_ClickPoint';
import DrawStraightLine from './02_DrawStraightLine';
import DrawCurvedLine from './03_DrawCurvedLine';
import DrawArea from './04_DrawArea';
import DrawPolygon from './05_DrawPolygon';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const PathTools = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>Drawing Path</div>
      </div>
      <div className={cx('body')}>
        <ClickPoint />
        <DrawStraightLine />
        <DrawCurvedLine />
        <DrawArea />
        <DrawPolygon />
      </div>
    </div>
  );
};

export default PathTools;
